import React, { createContext, useContext, useMemo } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import clsx from 'clsx';
import { DragHandleIcon } from '../icons/index.js';
const SortableItemContext = createContext({
    attributes: {},
    listeners: undefined,
    ref() { },
});
export const SortableItem = ({ children, id, disabled, className, }) => {
    const { attributes, isDragging, listeners, setNodeRef, setActivatorNodeRef, transform, transition, } = useSortable({ id, disabled });
    const context = useMemo(() => ({
        attributes,
        listeners,
        ref: setActivatorNodeRef,
    }), [attributes, listeners, setActivatorNodeRef]);
    const style = {
        opacity: isDragging ? 0.4 : undefined,
        transform: CSS.Translate.toString(transform),
        transition,
    };
    return (React.createElement(SortableItemContext.Provider, { value: context },
        React.createElement("li", { className: clsx(isDragging && 'shadow-lg', className), ref: setNodeRef, style: style }, children)));
};
export const DragHandle = ({ disabled }) => {
    const { attributes, listeners, ref } = useContext(SortableItemContext);
    return (React.createElement("button", Object.assign({ type: "button", className: clsx('h-4 w-4 shrink-0 cursor-grab mx-1 text-content-subdued disabled:opacity-60') }, attributes, listeners, { disabled: disabled, ref: ref }),
        React.createElement(DragHandleIcon, null)));
};
//# sourceMappingURL=SortableItem.js.map